import React from 'react'; 
import ArrowUpIcon from '@mui/icons-material/ArrowUpward'; 
import ArrowDownIcon from '@mui/icons-material/ArrowDownward';

import { useAppSelector, useAppDispatch } from '../../core/hooks';
import { savePrevValues, selectTraderType, selectView, updateSymbol, updateTraderType, updateView } from '../../core/reducers/reducer-main';
import { slimGreen, slimRed }  from '../../assets/colors/palette';
import styles from './changelog.module.css';
import { current } from '@reduxjs/toolkit';

interface ChangelogRowProps {
    data: any
}

const tradeValueRankings = [
    "Very Bearish", "Bearish", "Slightly Bearish", "Slightly Bearish to Neutral",
    "Neutral", "Neutral to Slightly Bullish", "Slightly Bullish to Neutral", "Slightly Bullish", 
    "Bullish", "Very Bullish"
];

const ChangelogRow = (props: ChangelogRowProps) => {
    const dispatch = useAppDispatch();    
    const traderType = useAppSelector(selectTraderType);
    const view = useAppSelector(selectView);    

    const keyToStringFormatting =  (input: string) => {
        return input.split('_').map((s:string) => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
    }
    const timeframeFormatted = ("timeframe" in props.data) ? keyToStringFormatting(props.data.timeframe) : "";
    const routingKeyFormatted = ("timeframe" in props.data) ? keyToStringFormatting(props.data.routing_key) : "";

    const arrowIcon = (("prev" in props.data) && ("current" in props.data)) ? ((props.data.prev < props.data.current) ? <ArrowUpIcon style={{color: slimGreen}}/> : <ArrowDownIcon style={{color: slimRed}}/>) :
        ("prev_text" in props.data && "next_text" in props.data) ? (tradeValueRankings.indexOf(props.data.prev_text) < tradeValueRankings.indexOf(props.data.next_text) ? <ArrowUpIcon style={{color: slimGreen}}/> : <ArrowDownIcon style={{color: slimRed}}/>) :
        (undefined); 

    const currentBiasText =  ("current" in props.data) ? ((props.data.current === 1) ? "Positive" : (props.data.current === -1) ? "Negative" : "Neutral") :
        ("next_text" in props.data) ? props.data.next_text :
        "Neutral"; 

    const lastUpdateDate = new Date(props.data.ts*1000);        

    const displayDate = [lastUpdateDate.getMonth() + 1, lastUpdateDate.getDate(), lastUpdateDate.getFullYear()].join('/');
    
    const hourFormatted = (lastUpdateDate.getHours() === 0 || lastUpdateDate.getHours() === 12 ) ? 12 : lastUpdateDate.getHours() % 12; 
    const minFormatted = lastUpdateDate.getMinutes() < 10 ? '0' + lastUpdateDate.getMinutes().toString() : lastUpdateDate.getMinutes()
    const timeTag = lastUpdateDate.getHours() < 12 ? 'am' : 'pm';
    const displayTime = [hourFormatted, minFormatted].join(':') + timeTag;

    const dateString = [displayDate, displayTime].join(' ');

    const rowClass = ((view === "timeframes-list") || (view === "traders-list")) ? ([styles.changelogRow, styles.changelogMultiRow].join(' ')) :
        (styles.changelogRow)

    const clickHandler = () => {
        if (view === "timeframes-list") {
            dispatch(savePrevValues());
            dispatch(updateTraderType('all'));
            dispatch(updateView('all')); 
            dispatch(updateSymbol(props.data.symbol));
        }
        else if (view === "traders-list") {
            dispatch(updateView(traderType)); 
            dispatch(updateSymbol(props.data.symbol));
        }
    }

    const secondRowComp = (view !== "traders-list") ? (
        <div>{timeframeFormatted} - {routingKeyFormatted}</div>
    ) : (undefined)

    return (
        <div className={rowClass} onClick={clickHandler}>
            <div>
                <div className={styles.symbolArrowRegion}>
                    <div className={styles.symbolText}>{props.data.symbol}</div> 
                    {arrowIcon}
                    <div className={styles.currentBiasText}>({currentBiasText})</div>
                </div>
                {secondRowComp}
            </div>
            <div>
                <div className={styles.dateString}>{dateString}</div>
            </div>
        </div>
    )
}

export default ChangelogRow; 